const formFamily = {
  w8ben: 'W-8BEN',
  w8bene: 'W-8BEN-E',
  w8eci: 'W-8ECI',
  w8exp: 'W-8EXP',
  w8imy: 'W-8IMY',
  w9: 'W-9',
  fatcacrsi: 'FATCA/CRS-I',
  fatcacrse: 'FATCA/CRS-E',
  crse: 'CRS-E',
  crsi: 'CRS-I',
  crscp: 'CRS-CP',
  rc518: 'RC-518',
  rc519: 'RC-519',
  getFamily(name) {
    const family = Object.entries(formFamily).filter(([k, v]) => k === name);
    return family.length > 0 && family[0];
  }
};

const formTypeDefinition = (value, code, description, family) => ({
  value,
  code,
  description,
  family: family ?? code,
  getFamilyName() {
    const familyDescription = formFamily[this.family];
    return familyDescription ?? this.family;
  }
});

const formTypes = {
  w8ben: formTypeDefinition(1, 'w8ben', 'W-8BEN Jul-2017', 'w8ben'),
  w8bene: formTypeDefinition(2, 'w8bene', 'W-8BEN-E Apr-2016', 'w8bene'),
  w8imy: formTypeDefinition(3, 'w8imy', 'W-8IMY Sep-2016', 'w8imy'),
  w9: formTypeDefinition(4, 'w9', 'W-9 Dec-2014', 'w9'),
  crse: formTypeDefinition(5, 'crse', 'CRSE 2017', 'crse'),
  crsebba: formTypeDefinition(6, 'crsebba', 'CRSEBBA 2017', 'crse'),
  crscp: formTypeDefinition(7, 'crscp', 'CRSCP 2017', 'crscp'),
  crsi: formTypeDefinition(8, 'crsi', 'CRSI 2017', 'crsi'),
  crsi_2024: formTypeDefinition(38, 'crsi_2024', 'CRSI 2024', 'crsi'),
  w8exp: formTypeDefinition(9, 'w8exp', 'W-8EXP Jul-2017', 'w8exp'),
  w8imy_2017: formTypeDefinition(10, 'w8imy_2017', 'W-8IMY Jun-2017', 'w8imy'),
  w8bene_2017: formTypeDefinition(11, 'w8bene_2017', 'W-8BEN-E Jul-2017', 'w8bene'),
  w8eci: formTypeDefinition(12, 'w8eci', 'W-8ECI Jul-2017', 'w8eci'),
  rc519: formTypeDefinition(14, 'rc519', 'RC-519'),
  rc518: formTypeDefinition(15, 'rc518', 'RC-518'),
  rc519_2024: formTypeDefinition(39, 'rc519_2024', 'RC-519 2024', 'rc519'),
  rc518_2024: formTypeDefinition(40, 'rc518_2024', 'RC-518 2024', 'rc518'),
  w8eci_2014: formTypeDefinition(16, 'w8eci_2014', 'W-8ECI Feb-2014', 'w8eci'),
  w8exp_2016: formTypeDefinition(17, 'w8exp_2016', 'W-8EXP Sep-2016', 'w8exp'),
  w8ben_2014: formTypeDefinition(18, 'w8ben_2014', 'W-8BEN Feb-2014', 'w8ben'),
  w9_2017: formTypeDefinition(19, 'w9_2017', 'W-9 Nov-2017', 'w9'),
  w9_2018: formTypeDefinition(20, 'w9_2018', 'W-9 Oct-2018', 'w9'),
  w9_2024: formTypeDefinition(36, 'w9_2024', 'W-9 Mar-2024', 'w9'),
  ucrscp_2019: formTypeDefinition(21, 'ucrscp_2019', 'Universal CRS-CP 2019', 'crscp'),
  ucrse_2025: formTypeDefinition(22, 'ucrse_2025', 'Universal CRS-E 2025', 'crse'),
  dt_crscp: formTypeDefinition(23, 'dt_crscp', 'Custom CRS-CP', 'crscp'),
  dt_crse: formTypeDefinition(24, 'dt_crse', 'Custom CRS-E', 'crse'),
  dt_crsi: formTypeDefinition(25, 'dr_crsi', 'Custom CRS-I', 'crsi'),
  w8ben_2021: formTypeDefinition(26, 'w8ben_2021', 'W-8BEN Oct-2021', 'w8ben'),
  w8eci_2021: formTypeDefinition(27, 'w8eci_2021', 'W-8ECI Oct-2021', 'w8eci'),
  w8bene_2021: formTypeDefinition(28, 'w8bene_2021', 'W-8BEN-E Oct-2021', 'w8bene'),
  w8imy_2021: formTypeDefinition(29, 'w8imy_2021', 'W-8IMY Oct-2021', 'w8imy'),
  fatca_crsi_2022: formTypeDefinition(31, 'fatca_crsi_2022', 'FATCA/CRS-I Jun-2022', 'fatcacrsi'),
  fatca_crse_2022: formTypeDefinition(32, 'fatca_crse_2022', 'FATCA-CRS-E Jul-2022', 'fatcacrse'),
  ucrsi_2025: formTypeDefinition(33, 'ucrsi_2025', 'Universal CRS-I 2025', 'crsi'),
  fatca_crsi_2023: formTypeDefinition(34, 'fatca_crsi_2023', 'FATCA/CRS-I May-2023', 'fatcacrsi'),
  fatca_crse_2023: formTypeDefinition(35, 'fatca_crse_2023', 'FATCA/CRS-E May-2023', 'fatcacrse'),
  w8exp_2023: formTypeDefinition(37, 'w8exp_2023', 'W-8EXP Oct-2023', 'w8exp'),

  getByValue(value) {
    const formType = Object.entries(formTypes).filter(([k, v]) => v && v.value === value).map(([k, v]) => v);
    return formType.length > 0 && formType[0];
  },
  getByCode(code) {
    const formType = Object.entries(formTypes).filter(([k, v]) => v && v.code === code).map(([k, v]) => v);
    return formType.length > 0 && formType[0];
  },
  getDescription(value) {
    const formType = this.getByValue(value);
    return (formType && formType.description) ?? value;
  },
  getFormName(family) {
    switch (family) {
      case 'fatcacrsi':
        return 'fatca_crsi-form';
      case 'fatcacrse':
        return 'fatca_crse-form';
      default:
        return `${ family }-form`;
    }
  }
};

export default formTypes;
